// extracted by mini-css-extract-plugin
export default {"secondary":"zero_decision_results_buttons-module__secondary--EQGQb"};